<template>
  <v-flex xs12>
    <v-card>
      <v-flex xs12 offset-xs10 v-if="isVisible">
        <AddNote :order="order" :type="type" @noteAdded="noteAdded"/>
      </v-flex>
      <v-toolbar class="firstPan" flat>
        <template v-slot:extension>
          <v-tabs
            v-model="firstPanTabs"
          >
            <v-tabs-slider></v-tabs-slider>
            <v-tab
              href="#firstPan1"
              class="primary--text"
            >
              Order Notes
            </v-tab>

            <v-tab
              href="#firstPan2"
              class="primary--text"
            >
              Examiner's Errors
            </v-tab>

            <v-tab
              href="#firstPan3"
              class="primary--text"
            >
              Data Entry's Notes
            </v-tab>

            <v-tab
              href="#firstPan4"
              class="primary--text"
            >
              Assigners's Notes
            </v-tab>
          </v-tabs>
        </template>

      </v-toolbar>

      <v-tabs-items v-model="firstPanTabs">
        <v-tab-item
          value="firstPan1"
        >
          <v-simple-table height="15rem">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" width="60%">Order Notes</th>
                  <th class="text-left" width="20%">Created By</th>
                  <th class="text-left" width="20%">Created On</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in orderNotes" :key="item.id">
                  <td>{{ item.note }}</td>
                  <td>{{ item.created_by.first_name }} {{ item.created_by.last_name }}</td>
                  <td>{{ item.created_on | formatDate }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-tab-item>
        <v-tab-item
          value="firstPan2"
        >
          <v-simple-table height="15rem">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" width="30%">Error Type</th>
                  <th class="text-left" width="30%">Note</th>
                  <th class="text-left" width="20%">Timestamp</th>
                  <th class="text-left" width="20%">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <v-combobox
                      v-model="selectedErrorType"
                      :items="errorTypes"
                      item-text="name"
                      label="Select Error Type"
                      chips
                      :disabled="loading"
                    >
                    <template v-slot:selection="data">
                        <v-chip
                          :key="JSON.stringify(data.item)"
                          v-bind="data.attrs"
                          :input-value="data.selected"
                          :disabled="data.disabled"
                        >
                        <v-avatar
                          class="accent white--text"
                          left
                          v-text="data.item.name.slice(0, 1).toUpperCase()"
                        ></v-avatar>
                          {{ data.item.name }}
                        </v-chip>
                    </template>
                    </v-combobox>
                  </td>
                  <td colspan="2">
                    <v-textarea
                      filled
                      v-model="feedback"
                      label="Note"
                      rows="2"
                      row-height="2"
                      shaped
                      required
                      :disabled="loading"
                    ></v-textarea>
                  </td>
                  <td><v-btn color="blue darken-1" text @click="addFeedback()" :disabled="dloading" :loading="loading">Add</v-btn></td>
                </tr>
                <tr v-for="(item, key) in examinerNotes" :key="item.id">
                  <td>{{ item.error_type.name }}</td>
                  <td>{{ item.note }}</td>
                  <td>{{ item.created_on | formatDate }}</td>
                  <td><v-btn color="blue darken-1" text @click="deleteFeedback(item.id, key)">Delete</v-btn></td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-tab-item>
        <v-tab-item
          value="firstPan3"
        >
          <v-simple-table height="15rem">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" width="60%">Order Notes</th>
                  <th class="text-left" width="20%">Created By</th>
                  <th class="text-left" width="20%">Created On</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in dataEntryNotes" :key="item.id">
                  <td>{{ item.note }}</td>
                  <td>{{ item.created_by.first_name }} {{ item.created_by.last_name }}</td>
                  <td>{{ item.created_on | formatDate }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-tab-item>
        <v-tab-item
          value="firstPan4"
        >
          <v-simple-table height="15rem">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" width="60%">Order Notes</th>
                  <th class="text-left" width="20%">Created By</th>
                  <th class="text-left" width="20%">Created On</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in assignersNotes" :key="item.id">
                  <td>{{ item.note }}</td>
                  <td>{{ item.created_by.first_name }} {{ item.created_by.last_name }}</td>
                  <td>{{ item.created_on | formatDate }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-flex>
</template>

<script>
// @ is an alias to /src
import Vue from 'vue'
import JwtService from '@/common/jwt.service'
import AddNote from '@/components/addNotes.vue'
import { GETNOTESLISTBYORDERID, DELETEFEEDBACKBYID, ADDFEEDBACK, GETFEEDBACKLISTBYORDERID, GETERRORTYPELIST } from '@/store/actions.type'
Vue.filter('formatAddress', function (value) {
  if (value) {
    return value.street + ', ' + value.county.name + ', ' + value.zip_code
  }
})

Vue.filter('formatDate', function (value) {
  if (value) {
    return new Date(value).toLocaleString(
      'en-US', { timeZone: 'America/Los_Angeles', hourCycle: 'h23' }
    ).replace(',', '')
  }
})

export default {
  name: 'notesManager',
  components: {
    AddNote
  },
  data () {
    return {
      loading: false,
      firstPanTabs: null,
      orderNotes: null,
      dataEntryNotes: null,
      examinerNotes: null,
      assignersNotes: null,
      selectedErrorType: null,
      errorTypes: [],
      feedback: null,
      isVisible: false,
      dloading: false
    }
  },
  props: {
    order: null,
    type: null
  },
  mounted () {
    this.isVisible = JwtService.addNotesCheck()
    if (!this.isVisible) {
      this.dloading = true
    }
    let orderNotePayload = {
      order__id: this.order.id,
      type: 'Order'
    }
    this.$store
      .dispatch(GETNOTESLISTBYORDERID, orderNotePayload)
      .then(response => {
        console.log(response)
        this.orderNotes = response
        console.log(this.orderNotes)
      })
    let dataEntryNotePayload = {
      order__id: this.order.id,
      type: 'DataEntry'
    }
    this.$store
      .dispatch(GETNOTESLISTBYORDERID, dataEntryNotePayload)
      .then(response => {
        console.log(response)
        this.dataEntryNotes = response
        console.log(this.dataEntryNotes)
      })
    let assignersNotePayload = {
      order__id: this.order.id,
      type: 'Assigner'
    }
    this.$store
      .dispatch(GETNOTESLISTBYORDERID, assignersNotePayload)
      .then(response => {
        console.log(response)
        this.assignersNotes = response
        console.log(this.assignersNotes)
      })
    let feedbackPayload = {
      order__id: this.order.id
    }
    this.$store
      .dispatch(GETFEEDBACKLISTBYORDERID, feedbackPayload)
      .then(response => {
        console.log(response)
        this.examinerNotes = response
      })
    this.$store
      .dispatch(GETERRORTYPELIST)
      .then(response => {
        console.log(response)
        this.errorTypes = response
      })
  },
  methods: {
    noteAdded (note) {
      note.created_by = JSON.parse(window.localStorage.getItem('auth')).user_data
      this.orderNotes.unshift(note)
    },
    deleteFeedback (feedbackId, index) {
      this.$store
        .dispatch(DELETEFEEDBACKBYID, { id: feedbackId })
        .then(response => {
          console.log(response)
          console.log('Index:', index)
          this.examinerNotes.splice(index, 1)
        })
    },
    addFeedback () {
      if (this.selectedErrorType) {
        this.loading = true
        this.dloading = true
        let feedbackPayload = {
          order: this.order.id,
          note: this.feedback,
          error_type: this.selectedErrorType.id
        }
        this.$store
          .dispatch(ADDFEEDBACK, feedbackPayload)
          .then(response => {
            this.loading = false
            this.dloading = false
            response.error_type = this.selectedErrorType
            this.feedback = null
            this.selectedErrorType = null
            console.log(response)
            this.examinerNotes.unshift(response)
          })
      }
    }
  }
}
</script>

<style>

body {
  font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
  font-size: 14px;
  line-height: 1.428571429;
  color: #333;
  background-color: #e7edf0;
}
.order-data-table {
  height: 100vh;
  position: fixed;
  bottom: 0;
  width: 100%;
  margin: auto
}
.v-data-table td {
  font-size: 10px;
  font-weight: bold;
}
.v-chip__content {
  font-size: 10px;
  font-weight: bold;
}
.v-data-table td, .v-data-table th {
  padding: 0 5px;
}

.statusTab {
    color: #fff !important;
    background-color: #00abab !important;
    border-color: #00abab;
    width: 120px;
    height: 50px !important;
    display: table-cell;
    vertical-align: middle;
    margin-right: 40px;
    font-size: 10px !important;
    font-weight: 900;
}

.activeStatusTab {
    background-color: #4e6692 !important;
    border-color: #4e6692 !important;
    color: #fff !important;
    width: 120px;
    height: 50px !important;
    display: table-cell;
    vertical-align: middle;
    margin-right: 40px;
    font-size: 10px !important;
    font-weight: 900;
}

.statusTabLine {
  width: 100%;
}

.statusTabLine:before {
    width: 85%;
    background: #d9544f;
    content: "";
    height: 1px;
    position: relative!important;
    padding: 2px;
    top: 40px!important;
    left: 0!important;
    margin: auto;
    display: inline-block;
}

.orderContainer {
  width: 90%;
  margin: auto;
  background-color: white;
  min-height: 800px;
}

.orderHeader {
  width: 90%;
  margin: auto;
  padding: 0px;
  border-bottom: none;
  font-family: 'Open Sans', sans-serif;
  font-size: 24px;
  font-weight: 600;
  padding-top: 10px;
  padding-bottom: 10px;
}

.firstPan > .v-toolbar__content {
    height: 0px !important;
}
.v-sheet--tile {
    height: 60px !important;
}

.v-tab {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 0;
  -ms-flex: 0 1 auto;
  flex: 0 1 auto;
  font-size: .875rem;
  font-weight: 500;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  letter-spacing: .0892857143em;
  line-height: normal;
  min-width: 90px;
  max-width: 360px;
  outline: none;
  padding: 0 16px;
  position: relative;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  -webkit-transition: none;
  transition: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: white !important;
  color: black !important;
  font-size: 13px;
}
</style>
